module.exports = __webpack_public_path__ + "img/wa.d0289dc0.png";